// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2CpTt","content":"RecentSearches_content__1K5Mq"};